import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_EXPIRY_DAYS_REQUEST: '',
  GET_EXPIRY_DAYS_SUCCESS: '',
  GET_EXPIRY_DAYS_FAILURE: '',

};

types = setStoreTypeValues(types, 'authExpiryDays');

export default types;
